
/**
 * <br>转换为\n
 * @param {String} str 文案
 */
function br2er(str) {
  str = str || ''
  return str.replace(/<br>/g, '\n')
}

/**
 * \n转换为<br>
 * @param {String} str 文案
 */
function er2br(str) {
  str = str || ''
  return str.replace(/\n/g, '<br>')
}

/**
 * 去除字符串连续的\n或<br>
 * @param {String} str 文案
 */
function deepTrim(str) {
  str = str || ''
  
  if (str.includes('<br>')) {
    str = str.replace(/(<br>)+/g, '<br>')
  }
  if (str.includes('\n')) {
    str = str.replace(/\n+/g, '\n')
  }
  return str
}

/**
 * 去除字符串前后的\n或<br>
 * @param {String} str 文案
 */
function trim(str) {
  str = str || ''
  if (str.includes('<br>')) {
    str = str.replace(/^<br>|<br>$/g, '')
  }
  if (str.includes('\n')) {
    str = str.replace(/^\n|\n$/g, '')
  }
  return str
}

export default {
  br2er,
  er2br,
  deepTrim,
  trim,

  // item_ad 和 share_item_ad 专用  <br>转\n
  adbr2er: (str) => {
    str = deepTrim(str)
    str = trim(str)
    return br2er(str)
  },

  // item_ad 和 share_item_ad 专用  \n转<br>
  ader2br: (str) => {
    
    str = deepTrim(str)
    str = trim(str)
    return er2br(str)
  },
}